import { inject } from '@angular/core';

import { AnyRecentItem, ResourceKind } from '@recruitee/dashboard-types';
import { provideRecentItem } from '@recruitee/dashboard-util';
import { I18nService } from '@recruitee/i18n';
import { RequisitionStatus } from '@recruitee/requisitions-types';

export interface RecentRequisition extends AnyRecentItem {
  type: ResourceKind.Requisition;
  count: number;
  imageUrl: null | string;
  initials: null | string;
  status: RequisitionStatus;
  title: string;
}

export const recentRequisitionProvider = provideRecentItem({
  useFactory: () => {
    const i18n = inject(I18nService);
    return {
      [ResourceKind.Requisition]: (item: RecentRequisition) => {
        const subheadingKey = {
          draft: 'app.requisitions.status.draft',
          pending: 'app.requisitions.status.pending',
          rejected: 'app.requisitions.status.rejected',
          approved: 'app.requisitions.status.approved',
          filled: 'app.requisitions.status.filled',
        }[item.status];
        return {
          id: item.id,
          imageType: 'icon',
          icon: 'nav-requisitions-outline',
          backgroundColor: 'colorBgRequisitionSubduedDefault',
          iconColor: 'colorIconRequisitionDefault',
          heading: item.title,
          subheading: i18n.translate(subheadingKey),
          route: ['/requisitions', item.id],
        };
      },
    };
  },
});
